export enum EDocumentoFiscal {
  NFe = 1,
  NFCe = 2,
  NFSe = 3,
  CCe = 4,
  MDFe = 5,
  CTe = 6,
}
